import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationContentWrapperCss,
  communicationImageWrapperCss,
  communicationRootCss,
  communicationTitleCss,
  communicationTitleGroupCss,
} from '~/pages/communication/libs/communicationBaseStyles'

export const GoodCompanyCommunicationStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div`
    ${communicationContentWrapperCss}
  `,

  ImageContainer: styled.div`
    position: relative;
    width: 100%;
  `,

  ImageWrapper: styled.div`
    ${communicationImageWrapperCss}
  `,

  ImageOverlay: styled.div`
    position: absolute;
    top: 24px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  ImageCounter: styled.span`
    font-family: 'Poppins', sans-serif;
    font-size: 31px;
    font-weight: 700;
    line-height: 1;
    color: #096ef9;
  `,

  ImageCounterLabel: styled.span`
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: rgba(29, 29, 29, 0.8);
  `,

  TitleGroup: styled.div`
    ${communicationTitleGroupCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #17202a;
  `,

  Button: styled.button`
    ${communicationButtonCss}
    margin-top: auto;
  `,
}
